import Vue from 'vue'
import Toastr from 'toastr2'
import 'toastr2/dist/toastr.min.css'

const toastr = new Toastr()
toastr.options.closeButton = true
toastr.options.timeOut = 5000
toastr.options.extendedTimeOut = 2000
toastr.options.progressBar = true
toastr.options.positionClass = 'toast-top-right'

Vue.prototype.$toast = toastr
